// Export the Logout API.
export default {
	apiService: {
		getLogout: {
			PATH_SEARCH: '/api/fusionAuth/logout',
			PATH_METHOD: 'delete',
		},
	},
};
